import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgCheck} from "~/assets/svg/check.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmCheckIcon: React.FC<IIconBase> = ({id, size = "xs", color = designColors.black, className}) => {
  return <SvgCheck id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
